/**
 * Filter options for the Modules tab.
 * Values must match what is stored in PLAIN_PERSONAL_DATA (data.school, data.location, data.program, data.year).
 */

export const MODULE_FILTER_LOCATIONS: string[] = [
  "Lusaka",
  "Central",
  "Copperbelt",
  "Luapula",
  "Northern",
  "Northwestern",
  "Southern",
  "Western",
  "Eastern",
  "Muchinga",
];

export const MODULE_FILTER_INSTITUTIONS: string[] = [
  "Chalimbana University",
  "Zambia College of Open and Distance Education",
  "Chainda School Of Nursing Sciences",
  "Evelyn Hone College of Applied Arts and Commerce",
  "Natural Resources Development College",
  "Zambia Air Services Training Institute",
  "Zambia Forestry College",
  "Zambia Institute of Chartered Accountants (ZICA)",
  "Zambia College of Agriculture",
  "Lusaka Trades Training Institute",
  "Kabwe Institute of Technology",
  "Kalulushi Trades Training Institute",
  "Ndola College of Biomedical Sciences",
  "Northern Technical College",
  "Copperbelt University",
  "Copperbelt Secondary Teachers College",
  "Kitwe College of Education",
  "Mufulira Trades Training Institute",
  "Luanshya Trades Training Institute",
  "Chingola Trades Training Institute",
  "Ndola College of Midwifery",
  "Ndola Institute of Midwifery",
  "Copperstone College of Nursing and Midwifery",
  "Dag Hammarskjold Institute of Health Sciences",
  "Ndola Teaching Hospital",
  "Bwafwano School of Nursing and Midwifery Sciences",
  "Konkola Copper Mines Nchanga Nursing and Midwifery School",
  "Mindolo Ecumenical Foundation",
  "Chreso University",
  "St. Magdalene Mission Hospital",
  "Northern Province School of Nursing",
  "Mpika Trades Training Institute",
  "Kasama Trades Training Institute",
  "Mansa Trades Training Institute",
  "Kawambwa Trades Training Institute",
  "Chipili Trades Training Institute",
  "Mansa College of Education",
  "Kasama College of Education",
  "Chibote Boarding School",
  "Solwezi Trades Training Institute",
  "Diamond TV Training School",
  "Chingola Institute of Community Studies",
  "Chongwe Trades Training Institute",
  "Chikuni Training Institute",
  "Kalomo Trades Training Institute",
  "Livingstone Institute of Business and Engineering Studies",
  "Maranatha School of Health Sciences",
  "Monze Trades Training Institute",
  "Victoria Falls School of Tourism and Hospitality",
  "St Pauls Mission Training Centre",
  "Namwianga Mission Hospital",
  "Zimba Mission Hospital",
  "Hwange Kamae Institute of Management Studies",
  "St. Francis Training Centre",
  "David Livingstone College of Education",
  "Senanga Trades Training Institute",
  "Limulunga Trades Training Institute",
  "Mongu Trades Training Institute",
  "Kaoma Trades Training Institute",
  "Sesheke Trades Training Institute",
  "Chipata Trades Training Institute",
  "Ukwimi Trades Training Institution",
  "Lundazi Trades Training Institute",
  "Isoka Trades Training Institue",
];

export const MODULE_FILTER_YEARS: string[] = ["Year 1", "Year 2", "Year 3"];

export const MODULE_FILTER_PROGRAMMES: string[] = [
  "Accountancy",
  "Accounting and Finance",
  "Accounting Technician",
  "Administrative and Secretarial Studies",
  "Adult Education",
  "Adult Education and Community Development",
  "Advanced Computer Studies",
  "Advanced Nursing Accident and Emergency",
  "Advanced Nursing Intensive Care",
  "Advanced Nursing Medical",
  "Advanced Nursing Mental Health",
  "Advanced Nursing Oncology",
  "Advanced Nursing Ophthalmic",
  "Advanced Nursing Orthopaedics",
  "Advanced Nursing Paediatrics",
  "Advanced Nursing Public Health",
  "Advanced Nursing Surgical",
  "Advanced Nursing Theatre",
  "Advanced Secretarial and Office Management",
  "Aeronautical Engineering",
  "Agricultural Engineering",
  "Air Navigation",
  "Air Traffic Control",
  "Anaesthesia",
  "Anaesthetic Nursing",
  "Animal Production",
  "Apiculture (Beekeeping)",
  "Applied Statistics",
  "Aquaculture",
  "Architecture and Building Services",
  "Audio-Visual Production and Technology",
  "Automotive Electronics",
  "Automotive Engineering",
  "Automotive Mechanics",
  "Automotive Mechanics Engineering",
  "Aviation Security",
  "Banking and Finance",
  "Biomedical Sciences",
  "Bricklaying and Masonry",
  "Bricklaying and Plastering",
  "Building and Civil Engineering",
  "Building and Construction",
  "Business Administration",
  "Business Studies",
  "Carpentry and Joinery",
  "Cartography and Geographic Information Systems",
  "Catering",
  "Ceramics",
  "Chemical Engineering",
  "Christian Counselling and Mentoring",
  "Civil Engineering",
  "Clinical Medicine",
  "Communication for Development",
  "Community Development",
  "Community Health (Nutrition)",
  "Community Mental Health",
  "Comprehensive Nursing Science",
  "Comprehensive Nursing Sciences",
  "Computer Applications",
  "Computer Studies",
  "Counselling",
  "Crop Production",
  "Cyber Security",
  "Dental Therapy",
  "Designing, Cutting and Tailoring",
  "Distance Education",
  "Electrical Engineering",
  "Electrical Power Engineering",
  "Electrical Technology",
  "Electronic and Telecommunication Engineering",
  "Electronics and Telecommunication Engineering",
  "Enrolled Nursing",
  "Entrepreneurship",
  "Environmental Health Sciences",
  "Fashion and Design",
  "Fashion Textile Design and Technology",
  "Fashion, Design and Garment Technology",
  "Film and Television",
  "Fine Art",
  "Food and Beverage",
  "Food Production",
  "Forensic Investigation",
  "Forestry",
  "Front Office Operations",
  "Gem-cutting",
  "General Agriculture",
  "General Nursing",
  "General Nursing Studies",
  "Guidance and Counselling",
  "Horticulture Science and Technology",
  "Hospitality",
  "Hospitality and Catering Management",
  "Hospitality Management",
  "Hotel and Catering",
  "Hotel Management",
  "Housekeeping",
  "Human Resource Management",
  "Information and Communication Technology",
  "Information Communication Technology",
  "Information Systems and Technology",
  "Information Technology",
  "Instrumentation",
  "Insurance",
  "Integrated Development Studies",
  "International Studies and Diplomacy",
  "Irrigation and Drainage",
  "Journalism and Communication",
  "Journalism and Mass Communication",
  "Land Economy",
  "Leadership and Management",
  "Legal Studies",
  "Library and Information Studies",
  "Maintenance Engineering",
  "Marketing",
  "Mechanical Engineering",
  "Media Studies",
  "Medical Imaging",
  "Medical Laboratory Sciences",
  "Medical Licentiate",
  "Mental Health",
  "Metal Fabrication",
  "Metallugy",
  "Metalwork and Jewellery",
  "Midwifery",
  "Midwifery (Advanced)",
  "Midwifery (General)",
  "Mine Surveying",
  "Mining Engineering",
  "Mortuary Sciences",
  "Multimedia and Graphic Design",
  "Nursing Assistant",
  "Office Management and Technology",
  "Ophthalmic Clinical Officer",
  "Ophthalmic Nursing",
  "Operations",
  "Orthopaedic and Trauma",
  "Orthopaedic and Trauma Plaster",
  "Paramedical Sciences",
  "Park and Wildlife Management",
  "Peace Building and Conflict Management",
  "Performing Arts",
  "Pharmaceutical Sciences",
  "Pharmacy",
  "Phlebotomy",
  "Photography",
  "Plumbing and Sheet Metal",
  "Power Electrical",
  "Printing and Graphics",
  "Procurement and Contract Management",
  "Procurement and Supply Chain Management",
  "Project Management",
  "Public Health",
  "Public Relations",
  "Public Sector Administration and Management",
  "Purchase and Supply (ZIPS)",
  "Purchasing and Supply (ZIPS)",
  "Purchasing and Supply Management",
  "Quantity Surveying",
  "Radiation Therapy",
  "Radiography",
  "Records and Management",
  "Records Management",
  "Registered Nursing",
  "Renewable Energy",
  "Risk Management",
  "Sales and Marketing Management",
  "Sawmilling and Mechanical Wood Processing",
  "Secretarial and Office Management",
  "Social Work",
  "Sound and Studio Techniques",
  "Special Education",
  "Stores Management",
  "Surveying",
  "Teaching English as a Second Language",
  "Telecommunications",
  "Textile",
  "Textile and Fashion Design",
  "Theology",
  "Theology and Ethics",
  "Tourism and Hospitality",
  "Town and Country Planning",
  "Transport and Logistics Management",
  "Water Well Drilling and Borehole Maintenance",
  "Welding and Fabrication",
  "Welding and Metal Fabrication",
  "Wildlife and Heritage",
  "Wildlife Management",
  "Wood Science and Technology",
];
